import type { JSX } from 'react';

import { Image } from '@change/ds-core-ui';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export function Photo({ id, url, mobileUrl }: Props): JSX.Element {
	return <Image aspectRatio="16:9" id={id} src={url || mobileUrl} alt="" className="w-full align-top" />;
}
